import { render } from "./PbxDashboardSelector.vue?vue&type=template&id=3d1fde34"
import script from "./PbxDashboardSelector.vue?vue&type=script&lang=js"
export * from "./PbxDashboardSelector.vue?vue&type=script&lang=js"

import "./PbxDashboardSelector.vue?vue&type=style&index=0&id=3d1fde34&lang=css"
script.render = render

export default script